var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left_icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dark:cc-fill-[#FFFFFFC2]",
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16634 3.3335C5.94468 3.3335 3.33301 5.94517 3.33301 9.16683C3.33301 12.3885 5.94468 15.0002 9.16634 15.0002C10.4766 15.0002 11.686 14.5682 12.6598 13.8388L15.5889 16.7679L16.7675 15.5894L13.8383 12.6603C14.5677 11.6865 14.9997 10.4771 14.9997 9.16683C14.9997 5.94517 12.388 3.3335 9.16634 3.3335ZM4.99967 9.16683C4.99967 6.86564 6.86515 5.00016 9.16634 5.00016C11.4675 5.00016 13.333 6.86564 13.333 9.16683C13.333 11.468 11.4675 13.3335 9.16634 13.3335C6.86515 13.3335 4.99967 11.468 4.99967 9.16683Z",
    fill: "black ",
    fillOpacity: 0.76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.55a436f32df396eba99210aa003b31a9.svg";
export { ForwardRef as ReactComponent };